import { render } from "./container.vue?vue&type=template&id=671d0492&scoped=true"
import script from "./container.vue?vue&type=script&lang=js"
export * from "./container.vue?vue&type=script&lang=js"

import "./container.vue?vue&type=style&index=0&id=671d0492&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671d0492"],['__file',"Scripts/components/pages/container.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "671d0492"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('671d0492', __exports__)) {
    api.reload('671d0492', __exports__)
  }
  
  module.hot.accept("./container.vue?vue&type=template&id=671d0492&scoped=true", () => {
    api.rerender('671d0492', render)
  })

}


export default __exports__